// CommonJS so next.config.js and next-sitemap.js (plain Node) can require it.

// Every deployment names production in canonical/og:url/hreflang/sitemap URLs,
// so a preview or staging copy never claims to be the original page.
const PRODUCTION_ORIGIN = 'https://curipod.com';

const NO_INDEX_VALUE = 'noindex, nofollow';

// Must match isProduction() in utils/client.ts (enforced by seo.test.ts), which
// next.config.js cannot import. PR previews use `pr`, staging `dev`, local dev is unset.
const isProductionAppEnv = appEnv => appEnv === 'prod';

const getRobotsHeaders = appEnv =>
  isProductionAppEnv(appEnv)
    ? []
    : [
        {
          source: '/:path*',
          headers: [{ key: 'X-Robots-Tag', value: NO_INDEX_VALUE }],
        },
      ];

module.exports = {
  PRODUCTION_ORIGIN,
  NO_INDEX_VALUE,
  getRobotsHeaders,
};
